import Decimal from 'decimal.js';

/**
 * Форматирование цифр
 */
export const formatNumeric = (
  value: string,
  numericType: string,
  precision: number,
  trimEndZeros = true,
  canNegative = false,
): string | number => {
  switch (numericType) {
    case 'number':
      return parseInt(value, 10) || 0;
    case 'float':
      const float = parseFloat(value);
      if (isNaN(float)) {
        return parseFloat('0').toFixed(precision);
      } else {
        return parseFloat(value).toFixed(precision);
      }
    case 'digitalString':
      return value.replace(/[^0-9]/gim, '');
    case 'money':
      const negative = canNegative && value.match(/^\D*-/) !== null;
      value = value.replace(/[,]/gim, '.');
      value = value.replace(/[^0-9.]|\s/gim, '');
      // вырежем все 0 в начале
      value = value.replace(/^0+/gim, '');

      return value.replace(/^(\d*)(\.?)(\S*)$/gim, (match, wholePart, delimeter, fractionPart) => {
        if (fractionPart !== '') {
          // вырежем все лишние точки
          fractionPart = fractionPart.replace(/[^0-9]|\s/gim, '');
          fractionPart = '.' + String(fractionPart).substring(0, precision);
        } else {
          fractionPart = '.';
        }

        // вырежем все 0 в конце
        if (trimEndZeros) {
          fractionPart = fractionPart.replace(/0+$/gim, '');
        }

        while (fractionPart.length <= 2) {
          fractionPart += '0';
        }

        if (wholePart === '') {
          wholePart = '0';
        }
        const newWholePart = wholePart
          .split('')
          .reverse()
          .join('')
          .match(/\d{1,3}/g)
          .map((part: any) => {
            return part.split('').reverse().join('');
          })
          .reverse()
          .join(' ');

        return (negative ? '-' : '') + newWholePart + fractionPart;
      });
    case 'roundedMoney':
      while (value.indexOf(' ') >= 0) {
        value = value.replace(' ', '');
      }

      const roundedValue = parseFloat(value).toFixed(2);

      return formatNumeric(roundedValue, 'money', precision, trimEndZeros, canNegative) as string;
    case 'decimal':
      value = value.replace(/[,]/gim, '.');
      value = value.replace(/[^0-9.]|\s/gim, '');
      // вырежем все 0 в начале
      value = value.replace(/^0+/gim, '');
      const decimalValue = new Decimal(value);

      return decimalValue.toFixed(precision).toString();
    case 'decimalString':
      value = value.replace(/[,]/gim, '.');
      if (value.endsWith('.')) {
        value += '0';
      }
      value = value.replace(/[^0-9.]|\s/gim, '');
      value = value.replace(/^0+/gim, '');

      return value;
    default:
      return value;
  }
};
